var _circle, _path;
const _excluded = ["svgRef"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgTelegramNew = _ref => {
  let {
      svgRef
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32",
    fill: "none",
    ref: svgRef
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 16,
    cy: 16,
    r: 16,
    fill: "#27A5E5"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.66208 15.1659C13.549 13.4724 16.1409 12.356 17.4378 11.8166C21.1406 10.2765 21.91 10.0089 22.4115 10.0001C22.5218 9.99815 22.7684 10.0255 22.9282 10.1551C23.0631 10.2646 23.1002 10.4124 23.1179 10.5162C23.1357 10.62 23.1578 10.8564 23.1402 11.0411C22.9396 13.1494 22.0713 18.2657 21.6296 20.6271C21.4427 21.6262 21.0747 21.9613 20.7184 21.994C19.9441 22.0653 19.3562 21.4823 18.6062 20.9907C17.4327 20.2215 16.7698 19.7426 15.6307 18.992C14.3142 18.1245 15.1676 17.6477 15.9178 16.8685C16.1142 16.6646 19.5257 13.5615 19.5918 13.28C19.6 13.2448 19.6077 13.1136 19.5297 13.0443C19.4518 12.975 19.3367 12.9987 19.2537 13.0175C19.136 13.0442 17.2613 14.2833 13.6296 16.7348C13.0975 17.1002 12.6155 17.2783 12.1836 17.2689C11.7076 17.2586 10.7918 16.9997 10.111 16.7785C9.27602 16.507 8.61238 16.3635 8.67016 15.9026C8.70026 15.6625 9.0309 15.4169 9.66208 15.1659Z",
    fill: "white"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgTelegramNew, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/telegram-new.424da292.svg";
export { ForwardRef as ReactComponent };